import VueNotifications from 'vue-notifications'

export const NotificationsMixin = {
    notifications: {
        showSuccessMsg: {
            type: VueNotifications.types.success
        },
        showErrorMsg: {
            type: VueNotifications.types.error
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixin.js